// extracted by mini-css-extract-plugin
export default {"disclaimer":"Pitg_K9WMsu2HiJuqrAG","noOptions":"sxO6GyLVx45gM9JByTwC"};